import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcListH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.006 50.994a3 3 0 0 1 3 3v.005a3 3 0 0 1-2.921 3h-.156A3 3 0 0 1 9 53.929a3 3 0 0 1 .65-1.79l.058-.074q.052-.06.107-.117.045-.05.092-.097.047-.044.096-.087.062-.058.129-.111l.062-.047a3 3 0 0 1 .179-.128l.04-.023a3 3 0 0 1 1.592-.461m0-17.995a3 3 0 0 1 3 3v.006a3 3 0 0 1-3.071 3h-.006A3 3 0 0 1 9 35.934a3 3 0 0 1 .65-1.79l.058-.074q.052-.06.107-.117.045-.05.092-.097.047-.044.096-.087.062-.058.129-.111l.057-.043a3 3 0 0 1 1.816-.617M12 14.994c.542 0 1.049.147 1.487.398l.04.024q.103.06.202.13l.055.041q.081.059.158.124.05.044.098.09.054.048.107.1.054.056.104.115.043.048.084.097.07.088.134.18l.022.032q.154.229.265.484l.01.024c.162.38.25.8.239 1.239a3 3 0 0 1-2.917 2.927h-.16a3 3 0 0 1-2.928-3v-.005a3 3 0 0 1 3-3M60 15.773a2.25 2.25 0 0 1 0 4.5H21a2.25 2.25 0 1 1 0-4.5zM60 33.773a2.25 2.25 0 0 1 0 4.5H21a2.25 2.25 0 1 1 0-4.5zM60 51.773a2.25 2.25 0 0 1 0 4.5H21a2.25 2.25 0 1 1 0-4.5z"
  }));
}
var IcListH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcListH72));

export { IcListH72 as I };
